export const APP_ROUTES = {
  LOGIN: "/login",
  DASHBOARD: "/dashboard",
  PATIENTREGISTER: "/Patientregister",
  VITAL: "/VitalDetails",
  MEDICALHISTORY: "/Medicalhistory",
  SLOTBOOKING: "/SlotBooking",
  SIGNUP: "/Signup",
  QUEUEMANAGEMENT: "/QueueManagement",
  PATIENTPREVIEW: "/PatientPreview",
  BOOKSERVICE: "/BookService",
  DOCTORONBOARDING: "/DoctorOnboarding",
  PAYMENTPAGE: "/Paymentpage",
  ORDERSTATUS: "/orderStatus",
  REPORTS: "/reports",
  PAYMENTDETAILS: "/PaymentDetails",
  PATIENTDETAILS: "/PatientDetails",
  FULLSCREENLOADER: "/FullScreenLoader",
  VIEWVITAL: "/ViewVital",
  SMART_VITAL_FORM: "/FormComponent",
  VIDEO_CAPTURE: "/VideoCapture",
  LABCART: "/Labcart",
  CARTDROPDOWN: "/CartDropdown",
  MEDICINECARTPAGE: "/MedicineCartPage",
  LABCARTPAGE: "/LabCartPage",
  CARESATHI: "/caresathi",
  DELIVERY_MODAL: "/DeliveryModal",
  SHARECALL: "/sharecall/:id/:type",
  PATIENTDETAILSDATA: "/PatientDetailsdata",
  PATIENTVIEW: "/PatientView",
  CLINICDIAGNOSTICDETAILS: "/ClinicDiagnosticDetails",
  CLINICMEDICINEDETAILS: "/ClinicMedicineDetails",
  CLINICRADIOLOGYDETAILS: "/ClinicRadiologyDetails",
  CLINICSURGERYDETAILS: "/ClinicSurgeryDetails",
  CLINICAMBULANCEDETAILS: "/ClinicAmbulanceDetails",
  BOOKSERVICESCARD: "/BookServicescard",
  MYPROFILE: "/myprofile",
  ADMIN_PROFILE: '/myprofile/admin',
  CHANGE_PASSWORD: '/changePassword',
  FEEDBACK: '/feedback',
  CLINICSTAFFOB: '/clinicStaffOB',
  DOCTORLIST: '/DoctorList',
  RECEPTIONISTLIST: '/receptionistList',
  PATIENTLIST: '/patientList',
  ORDER_TRACKING: '/order-tracking/:clinicId/:orderId',
  DOCTOR_DETAILS: '/doctor-details/:doctorId',
  ADD_ADDRESS: '/AddAddress',
  CLINIC_ONBOARDING: '/clinicOnboarding',
  HOSPITAL_LIST: '/hospitalList',
  DOCTOR_EDIT: '/doctor-edit',
  CLINIC_STAFF_EDIT: '/clinicStaffEdit',
  ADMIN_ONBOARDING: '/adminOnboarding',
  ADMIN_LIST: '/adminList',
  PATIENT_FEEDBACK: '/patientfeedback/:clinicId',
  CUREBAY_DOCTOR_ONBOARDING: '/CurebayDoctorOnboarding',
  CUREBAY_DOCTOR_VERIFY: '/CurebayDoctorVerify',
  CUREBAY_DOCTOR_LIST: '/CurebayDoctorList',
  CUREBAY_PATIENT_FEEDBACK: '/CurebayPatientFeedback',
  CUREBAY_PAYMENT_INVOICE: '/CurebayPaymentInvoice',
  CUREBAY_SLOT_MANAGEMENT: '/CurebaySlotManagement',
  CUREBAY_LEAVE: '/CurebayLeave',
  CUREBAY_DIAGNOSIS_MASTER: '/CurebayDiagnosisMaster',
  CUREBAY_DOCTOR_PAYMENTS: '/CurebayDoctorPayments',
  CUREBAY_DOCTOR_EDIT: '/CurebayDoctorEdit',
  VIEW_PRESCRIPTION: '/ViewPrescription',
  EDIT_PRESCRIPTION: '/EditPrescription',
  PATIENT_PENDING_LIST: '/PatientPendingList',
  CONSULTATION_LIST: '/ConsultationList',
  CAMP_DETAILS: "/camp-details",
  HOSPITAL_CAMP_DETAILS: "/hospital-camp-details",
  CAMP_PATIENT_DETAIL: "/camp-patient-detail",
  KAVACH_ENROLLMENT: "/kavach-enrollment",
  CUREBAY_REFERRAL_DOCTORS: "/CurebayReferralDoctors",
  CUREBAY_REFERRAL_BOOKING: "/CurebayReferralBooking",
  CUREBAY_ORDER_STATUS: "/CurebayOrderStatus",
};
